var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Artboard","fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},[React.createElement("rect",{"id":"Bar","width":"24","height":"3","x":"0","y":"6","fill":"#142B6F","fillRule":"nonzero","rx":"1.5","key":0}),React.createElement("rect",{"id":"Bar","width":"24","height":"3","x":"0","y":"15","fill":"#142B6F","fillRule":"nonzero","rx":"1.5","key":1})]));
}

IconHamburger.defaultProps = {"width":"24","height":"24","version":"1.1","viewBox":"0 0 24 24"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
